module.exports = __webpack_public_path__ + "img/tubiao-30.ce275d0c.png";